export default "__VITE_ASSET__4f70120e__"